import Speaker1 from "../images/speakers/temidayo.jpeg";
import Speaker2 from "../images/speakers/Adeoluwa.jpeg";
import Speaker3 from "../images/speakers/Joey.jpeg";
import Speaker4 from "../images/speakers/Toluwanimi.jpeg";
import Speaker5 from "../images/speakers/Blessing.jpeg";
import Speaker6 from "../images/speakers/kunbi.jpeg";

const speakerData = [
  {
    key: 1,
    Image: Speaker1,
    name: "Dr. Temidayo Oniosun",
    job: "Founder, Space in Africa",
    instagram: "https://www.instagram.com/temidayooniosun/?hl=en",
    // twitter: "https://twitter.com/Officiallolo1",
    // facebook: "https://web.facebook.com/officiallolo1omotunde",
    about: `Temidayo Oniosun is the Founder and Managing Director of Space in Africa, the leading source of market intelligence for the African space and satellite industry. With nearly a decade of experience, he advises governments, international organizations, and commercial stakeholders across the space value chain. He has led strategic consulting projects for institutions like the African Union Commission and Angola’s National Space Management Office (GGPEN), including socio-economic studies and commercialization strategies.
Recognized for his impact in the industry, Temidayo was named a Karman Fellow in 2020 and a Forbes Africa 30 Under 30 honoree in 2021. His expertise is frequently featured by major global media outlets such as BBC, CNN, Al Jazeera, CNBC, CGTN, Forbes Africa, and Voice of America, where he provides analysis on Africa’s growing space programs.
Temidayo holds a B.Tech in Meteorology from the Federal University of Technology, Akure, a Master’s in Satellite Applications from the University of Strathclyde, and a PhD from the University of Delaware. He is a Research Affiliate at the MIT Media Lab and a member of the World Economic Forum’s Global Future Council on Space Technologies`,
  },
  {
    key: 2,
    Image: Speaker2,
    name: "Adeoluwa Akintoba",
    job: "Actor",
    instagram: "https://www.instagram.com/adeyybasqi/?hl=en",
    // twitter: "https://twitter.com/ToluwaniGeorge_",
    // tiktok: "https://www.tiktok.com/@toluwanigeorge",
    about: `Adeoluwa Akintoba has recently been recognized as one of TNC Africa’s “7 Actors to Watch,” he has also earned Scream Awards nominations and was honored by the Ooni of Ife in 2024 as one of 100 exceptional young Africans.
A versatile actor, filmmaker, voice-over artist, and speaker, Akintoba is passionate about entertainment and youth development.
His recent projects, "The Artifact and Makemation" which is Africa’s first tech AI-focused film is a major milestone
He has been featured in over 25 productions, including Slum-King, Sista, MTV Shuga. His lead role in Slum-King showcased his depth and rising influence in Nollywood.
Beyond acting, Adeoluwa is a vibrant host and speaker known for inspiring young talents.`,
  },
  {
    key: 3,
    Image: Speaker3,
    name: "Joey Ossai Obassi ",
    job: " CEO, The Connecting Bridge",
    instagram: "https://www.instagram.com/joeyoflagos/?hl=en",
    // twitter: "https://twitter.com/HannahMoses01",
    // linkedin: "https://ng.linkedin.com/in/ayodeletim",
    about: `Joey Ossai Obassi is the Founder and CEO of The connecting bridge, a marketing agency, based in Lekki, Lagos, that specialises in media production and digital marketing for brands
A prestigious associate member  of APCON, He is also a director and an entertainment and media consultant. 
An alumnus of Ajayi Crowther University, His brand has collaborated an array of reputable brands such as Pepsi, Lipton Ice Tea, Opay and other prominent businesses.
He is causing a revolution in the media space, one brand at a time.
    `,
  },
  {
    key: 4,
    Image: Speaker4,
    name: "Toluwanimi Lazarus ",
    job: "Mental Health Advocate",
    instagram: "https://www.instagram.com/toluwa_lazarus/?hl=en",
    // twitter: "https://twitter.com/oluomotoso",
    // linkedin: "https://www.linkedin.com/in/oluomotoso/",
    about: `Toluwanimi Lazarus is a First Class graduate of Communication and Language Arts from the University of Ibadan, Oyo state. An avid scholar and knowledge enthusiast, she is currently studying for an MSc in Social Justice and Community Action at the
University of Edinburgh, UK. She is a passionate mental and emotional health advocate dedicated to empowering individuals and help them not just heal, but thrive. As a certified solution-focused counselor and Fellow of the Mental Health Fellowship, Toluwanimi has supported several individuals
online and offline to lead better lives. Her expertise spans several critical areas and in recognition of her amazing work, She has been featured on prominent platforms, including Building Nations Initiative, Youths in Crisis Situations, Success Fort Initiative and several others.`,
  },
  {
    key: 5,
    Image: Speaker5,
    name: "Blessing Chesterfield ",
    // job: "Managing Director at The Wash Room Limited",
    instagram: "https://www.instagram.com/theblessen_field/?hl=en",
    // facebook: "https://www.facebook.com/ayodele.oluwagallant/",
    // linkedin: "https://www.linkedin.com/in/ayodele-jonathan-ajayi-41944aa4/",
    about: `An iconic woman, redefining how unemployment is tackled across the continent, Blessing Chesterfield has recently been named among Africa’s 100 most impactful individuals and is a recipient of the Yessiey Award. Her brainchild, Codedjobs, has transformed the employment landscape in Nigeria and beyond, empowering over 1,600 individuals and counting which is an astonishing feet! Codedjobs, an innovative platform created by Blessing, bridges the gap between job seekers and opportunities. By offering resources, skill development, and entrepreneurial guidance, the platform has addressed key issues of unemployment and underemployment..

    `,
  },
  {
    key: 6,
    Image: Speaker6,
    name: "Kunbi Adeoti",
    job: "@kunbiadeoti",
    // facebook: "https://www.facebook.com/corneliussegun.ojo.5",
    instagram: "https://www.instagram.com/kunbiadeoti/?hl=en",
    // linkedin: "https://twitter.com/Inemesit_hanson",
    about: `A certified global HR professional (MBA, GPHR, SPHRi, SHRM-SCP, MCIPM, among others), ’Kunbi Adeoti is a respected leadership speaker, mentor, and board member. Named Peak Performing Woman of the Year in 2023, Adeoti serves as a Non-Executive Director at Leadway Health and sits on the Management Board of Pistis Life and Leadership Institute. She is also active in SHRM Lagos, the HR Forbes Council, and the European Mentorship and Coaching Council.
With over 24 years of experience, she has led HR transformations across startups and multinationals in Sub-Saharan Africa, including strategic roles at Standard Chartered Bank, Airtel, and Alcatel-Lucent. 
Currently, she is currently the Chief People Experience Officer at Leadway Group.`,
  },
];
const speakerTitle = {
  main_header: "Speakers",
  mini_header: "Our Speakers",
};

export default speakerData;
export { speakerTitle };
